import React from 'react';
import {CommonShow} from '../Common';
import {getFields} from './Common';

export const MaterialTCO2Show = props => (
  <CommonShow
    {...{
      ...props,
      fields: getFields(),
    }}
  />
);
